import { BaseRepository } from '@app/src/common/repository/BaseRepository';
import {
  ICompanyResource,
  ICompanyLocation,
  ILocationName,
  ILocationTreeItem
} from '../model/Location';

class ResourceRepository extends BaseRepository {
  protected locationTreeUrl: string = `${this.userManagementUrl}/locations/tree`;
  protected locationsUrl: string = `${this.userManagementUrl}/locations`;
  protected resourcesUrl: string = `${this.userManagementUrl}/resources`;
  protected companiesUrl: string = `${this.userManagementUrl}/companies`;

  getLocationTree = async () => {
    return this.callGet<ILocationTreeItem[]>(this.locationTreeUrl).then(
      response => response.data
    );
  };

  getCompanyResources = async (id: string) => {
    return this.callGet<ICompanyResource[]>(
      `${this.companiesUrl}/${id}/resources`
    ).then(response => response.data);
  };

  updateCompanyResources = async (id: string, resourceIds: string[]) => {
    return this.callPut(`${this.companiesUrl}/${id}/resources`, {
      resourceIds
    });
  };

  getResourceNames = async (id: string) => {
    return this.callGet<{ id: string; path: string }[]>(
      `${this.companiesUrl}/${id}/resources/paths`
    ).then(response => response.data);
  };

  getLocationNames = async (companyId?: string): Promise<ILocationName[]> => {
    return this.callGet<ILocationName[]>(
      `${this.locationsUrl}/names`,
      companyId ? { companyId } : undefined
    ).then(response => response.data);
  };

  getLocation = async (id: string): Promise<ICompanyLocation> => {
    return this.callGet<ICompanyLocation>(`${this.locationsUrl}/${id}`).then(
      response => response.data
    );
  };

  createLocation = async (data: ICompanyLocation): Promise<string> => {
    return this.callPost<string>(this.locationsUrl, data).then(
      response => response.data
    );
  };

  updateLocation = async (id: string, data: ICompanyLocation) => {
    return this.callPut(`${this.locationsUrl}/${id}`, data);
  };

  deleteLocation = async (id: string) => {
    return this.callDelete(`${this.locationsUrl}/${id}`);
  };

  setLocationAsMain = async (id: string) => {
    return this.callPut(`${this.locationsUrl}/${id}/main`, undefined);
  };

  getResource = async (id: string): Promise<ICompanyResource> => {
    return this.callGet<ICompanyResource>(`${this.resourcesUrl}/${id}`).then(
      response => response.data
    );
  };

  createResource = async (data: ICompanyResource): Promise<string> => {
    return this.callPost<string>(this.resourcesUrl, data).then(
      response => response.data
    );
  };

  updateResource = async (id: string, data: ICompanyResource) => {
    return this.callPut(`${this.resourcesUrl}/${id}`, data);
  };

  deleteResource = async (id: string) => {
    return this.callDelete(`${this.resourcesUrl}/${id}`);
  };
}

export default new ResourceRepository();
